module.exports = __webpack_public_path__ + "static/media/Base feature icon.af60ec15.svg";